import { render } from "./MovieTag.vue?vue&type=template&id=39ec66b6&scoped=true"
const script = {}

import "./MovieTag.vue?vue&type=style&index=0&id=39ec66b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ec66b6"]])

export default __exports__